import './wagegroup.less';

angular.module("tromanWeb").controller('WageGroupController', ['wageGroupShared', 'systemInfo', function (wageGroupShared, systemInfo) {
    this.wageGroup = wageGroupShared.wageGroup;
    this.systemInfo = systemInfo;
}]);
